var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mappin",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.67,36.76c0-.13,0-.27,0-.38A36.81,36.81,0,0,0,56.65.3L56.23.23c-.3-.05-.6-.11-.9-.15h-.18A37.09,37.09,0,0,0,50-.3,36.63,36.63,0,0,0,13.33,36.38c-.08,3.07.19,30.95,35.16,62.74a2.21,2.21,0,0,0,1.5.58,2.19,2.19,0,0,0,1.49-.58C86.44,67.34,86.77,40.12,86.67,36.76ZM50,94.46c-32-29.86-32.3-55.14-32.22-58v-.12h0A32.24,32.24,0,0,1,55.61,4.63l.17,0c.61.11,1.22.23,1.82.38h0A32.37,32.37,0,0,1,82.22,36.38h0a.24.24,0,0,0,0,.12v.1s0,.06,0,.1,0,.13,0,.35c0,.7,0,1.87-.23,3.46l-.06.42q0,.33-.09.69c0,.29-.08.59-.14.91l0,.23C80.07,52.34,73.85,72.2,50,94.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,16.21a20.17,20.17,0,1,0,7.54,38.88A2.22,2.22,0,1,0,55.87,51,15.54,15.54,0,0,1,50,52.11,15.73,15.73,0,1,1,65.72,36.38a15.48,15.48,0,0,1-1.64,7,2.22,2.22,0,0,0,4,2,20,20,0,0,0,2.1-9A20.2,20.2,0,0,0,50,16.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/mappin.ed1a9e36.svg";
export { ForwardRef as ReactComponent };